export default __webpack_public_path__ + "static/mob02-24c907c7bac898338d881b76316f3014.png";